<template lang="pug">
    v-layout(row style="height: 100%;")
        v-flex.xs6.pa-1.mr-2.title(justify-start) 
            v-tooltip(top)
                span(slot="activator") {{item.wh_product.name }}
                span.tooltip-text.title {{item.wh_product.name}}
            
        v-divider(vertical)
        v-flex.xs2.text-sm-center.pricing-area.title(v-if="payer=='SE' && (paymentMethod ==1 || paymentMethod ==null)" justify-center) {{item.net_price | mixFormatCurrency}}
        v-flex.xs2.text-sm-center.pricing-area.title(v-else justify-center) {{item.price | mixFormatCurrency}}
        
        v-divider(vertical)
        v-flex.xs2.mr-2.text-sm-center.pricing-area.title(justify-center)  {{showDiscount}}
        v-divider(vertical)
        v-flex.xs2.text-sm-center.pricing-area.title(v-if="payer=='SE' && (paymentMethod ==1 || paymentMethod ==null)" justify-center)  {{item.new_net_subtotal | mixFormatCurrency}}
        v-flex.xs2.text-sm-center.pricing-area.title(v-else justify-center)  {{item.total | mixFormatCurrency}}
        
</template>

<script>
/**
 * Component to show details of an item in the cart items list.
 */
import CurrencyUtils from '@/mixins/CurrencyUtils'
import TextFormatting from '@/mixins/TextFormatting'
import {mapState} from 'vuex'
export default {
    name: 'sales-cart-details',
    props: {
        /**
         * @description
         * Item to display
         * @type {object}
         */
        item: {
            type: Object,
            default: {}
        }
    },
    computed: {

        ...mapState('CashDeskModule',{
            payer: 'payer',
            paymentMethod : 'paymentMethod'
        }),
        /**
         * @description
         * Formats and show the item's manual discout if it has any.
         * @returns {string}
         */
        showDiscount: function(){
            if(this.item.discount_or_charge_percentage>0){
                return this.item.discount_or_charge_percentage.toLocaleString() + '%'
            }
            else if(this.item.discount_or_charge_value>0){
                return '$'+this.item.discount_or_charge_value.toLocaleString()
            }
            else{
                return '-'
            }
        },
    },
    mixins: [CurrencyUtils, TextFormatting],
    mounted:function(){
    }
}
</script>

<style lang="scss" scoped>
    .upc-area{
        margin-top: 3px;
        display:flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .pricing-area{
        padding-top: 14px;
    }
    .title{
        font-size:13px !important;
    }
</style>

